/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalApiMonitoringList } from '../../models/external-api-monitoring-list';

export interface GetExternalApisMonitoring$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
}

export function getExternalApisMonitoring(http: HttpClient, rootUrl: string, params?: GetExternalApisMonitoring$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalApiMonitoringList>> {
  const rb = new RequestBuilder(rootUrl, getExternalApisMonitoring.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExternalApiMonitoringList>;
    })
  );
}

getExternalApisMonitoring.PATH = '/external-apis/monitoring';
